import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import { Client, ServiceTypeDataIn } from '../../../../../api/api-reference';

@Component({
  selector: 'app-service-type-setup',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule, AngularSvgIconModule],
  templateUrl: './service-type-setup.component.html',
  styleUrl: './service-type-setup.component.scss',
})
export class ServiceTypeSetupComponent implements OnInit {
  @Input() selectedServiceType: string | null = null;
  @Output() close = new EventEmitter<boolean>();
  data: ServiceTypeDataIn = new ServiceTypeDataIn();

  @ViewChild('crudform') crudform!: NgForm;
  constructor(
    private client: Client,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.getServiceType();
  }

  toggleModal(reaload?: boolean) {
    this.close.emit(reaload);
  }

  getServiceType() {
    if (this.selectedServiceType) {
      this.client.getServiceType(this.selectedServiceType).subscribe({
        next: (response) => {
          this.data.id = response.id;
          this.data.name = response.name ?? '';
          this.data.code = response.code ?? '';
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    }
  }
  onSubmit() {
    this.client.saveServiceType(this.data).subscribe({
      next: (response) => {
        this.toastr.success(response);
        this.toggleModal(true);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}
